﻿import { genericSearch, genericSearchOptions } from './ts/GenericSearch';
function resultBuilder (element: HTMLElement, results: any): void {
   const ddlCountry = document.querySelector<HTMLSelectElement>('#ddlCountries');
   const ddlUniversities = document.querySelector<HTMLSelectElement>('#ddlUniversities');
   const ddlFieldsOfStudy = document.querySelector<HTMLSelectElement>('#ddlFieldsOfStudy');

   replaceSelectOptions(ddlCountry, results.countries, results.selectedCountry);
   replaceSelectOptions(ddlUniversities, results.universities, results.selectedUniversity);
   replaceSelectOptions(ddlFieldsOfStudy, results.fieldsOfStudy, results.selectedFieldOfStudy);

   element.innerHTML = '';
   results.resultList.forEach((value: any, index: number) => {
      let row = document.createElement('tr');
      let endorsed = value.endorsed ? '<img src="/img/uarticicon_24px.png" alt="UArctic Endorsed"/>' : '';
      let level = value.level ? value.level : '';
      row.innerHTML = `<td data-search-score="${ value.score }">${ index + 1 }</td><td><a data-teaser="${value.teaser}" href="${ value.detailsUrl }">${ value.name }</a></td><td><a href="${ value.organizationUrl }" target="_blank" rel="nofollow">${ value.organizationName }</a></td><td>${ value.country }</td><td>${ level }</td><td>${ value.itemType } ${ endorsed}</td>`;
      element.appendChild(row);
   });
}

const opt: genericSearchOptions = {
   formSelector: '#scSearchForm',
   resultsTableBodySelector: '#search_results_tbody',
   resultsTableSelector: '#search_results',
   messageSelector: '#search_message',
   filterButtonSelector: '#btn_collapse_form',
   formCollapseSelector: '#searchAdvanced',
   queryUrl: '/Umbraco/Api/StudiesCataloguApi/Search/',
   resultsBuilder: resultBuilder
}

const replaceSelectOptions = (select: HTMLSelectElement | null, options: any[], current: any): void => {
   if (!select) return;
   select.innerHTML = '';

   let opt = document.createElement('option');
   opt.value = '';
   opt.textContent = '--- All ---';
   opt.selected = (!current || current === '');
   select.appendChild(opt);

   options.forEach(option => {
      let opt = document.createElement('option');
      opt.value = option.value;
      opt.textContent = option.text;
      opt.selected = (current && current == option.value);
      select.appendChild(opt);
   });
}

genericSearch(opt);
